import { AUTH_API_BASE_URL, COMPANY_API_BASE_URL } from 'constants/config';
import httpRequest from './config/HttpRequest';

export type PublicRegisterPayload = {
  company: {
    name: string;
    address: string;
    timeZone: string; // tzCode
    email: string;
    phoneNumber: string; // numeric string, max 15
    usdot: string;
  };
  user: {
    email: string;
    password: string; // 8-20
    userName: string; // same as email
    firstName: string;
    lastName: string;
    timeZone: string; // tzCode
    gender: 'Male' | 'Female' | 'Others';
    phoneNumber: string;
    role?: string;
  };
  office: {
    name: string; // e.g., Head Office
    address: string;
    phoneNumber: string;
    timeZone: string; // tzCode
    country: string; // United States
    state: string; // full state name
    city: string;
  };
};

export type PublicRegisterResponse = {
  message: string;
  data: unknown;
};

const publicRegisterApi = {
  register: async (body: PublicRegisterPayload): Promise<PublicRegisterResponse> => {
    const response = await httpRequest.request({
      baseURL: AUTH_API_BASE_URL,
      url: '/Auth/registerTenant',
      method: 'POST',
      data: body,
      header: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  },
};

export default publicRegisterApi;
